declare global {
  interface Window {
    readonly ga?: UniversalAnalytics.ga
  }
}

const getAnalytics: () => undefined | UniversalAnalytics.ga = () => window.ga

export { getAnalytics }
